<template>
  <div class="cart">
    <van-nav-bar
      style="
        position: fixed;
        z-index: 9999;
        background-color: white;
        width: 100%;"
      title="购物车"
      :right-text="rightText"
      @click-right="onClickRight"
    />
    <div style="height: 50px"></div>
    <van-checkbox-group
      class="card-goods"
      v-model="checkedCartItem"
      v-if="cartList.length > 0"
    >
      <div v-for="item in cartList" :key="item.id" class="card-goods__item">
        <van-checkbox :name="item.id" @click="checkInfo(item)"></van-checkbox>
        <van-card
          style="margin-left: 15px"
          :title="item.name"
          :desc="item.descript"
          :price="item.price"
          :thumb="item.picture"
        >
          <div slot="footer">
            <van-stepper
              v-model="item.count"
              @change="stepperEvent(item, arguments)"
              disableInput
            />
          </div>
        </van-card>
      </div>
      <br/><br /><br /><br /><br />
    </van-checkbox-group>
    <van-submit-bar
      v-show="!showEdit"
      :price="totalPrice"
      :disabled="!checkedCartItem.length"
      :button-text="submitBarText"
      @submit="toCheckOut"
      v-if="cartList.length > 0"
    >
      <van-checkbox
        v-model="checkedAll"
        @click="checkAll"
        style="padding: 0 10px"
        >全选</van-checkbox
      >
    </van-submit-bar>
    <van-submit-bar
      v-show="showEdit"
      :price="totalPrice"
      :disabled="!checkedCartItem.length"
      button-text="删除"
      @submit="remove"
      v-if="isLogin && cartList.length > 0"
    >
      <van-checkbox
        v-model="checkedAll"
        @click="checkAll"
        style="padding: 0 10px"
        >全选</van-checkbox
      >
    </van-submit-bar>
    <div class="no-data" v-if="isLogin && cartList.length === 0">
      <p style="text-align: center; color: lightgray">
        <van-icon name="cart-o" style="text-align: center" size="3rem" /><br />
        购物车还是空的
      </p>
      <van-button type="default" block round @click="toHome">去逛逛</van-button>
    </div>
    <div>
      <!-- <van-tabbar v-model="activeses">
        <van-tabbar-item icon="home-o" replace to="/home">首页</van-tabbar-item>
        <van-tabbar-item icon="search" replace to="/search"
          >分类</van-tabbar-item>
        <van-tabbar-item icon="cart-o" replace to="/cart"
          >购物车</van-tabbar-item
        >
        <van-tabbar-item icon="user-o" replace to="/user">我的</van-tabbar-item>
      </van-tabbar> -->
    </div>
  </div>
</template>

<script>
import {
  Button,
  Card,
  Checkbox,
  CheckboxGroup,
  Icon,
  NavBar,
  Stepper,
  SubmitBar,
  Tabbar,
  TabbarItem,
  Toast,
} from "vant";

export default {
  components: {
    [Card.name]: Card,
    [Checkbox.name]: Checkbox,
    [SubmitBar.name]: SubmitBar,
    [CheckboxGroup.name]: CheckboxGroup,
    [NavBar.name]: NavBar,
    [Tabbar.name]: Tabbar,
    [TabbarItem.name]: TabbarItem,
    [Stepper.name]: Stepper,
    [Button.name]: Button,
    [Icon.name]: Icon,
    [Toast.name]: Toast,
  },

  data() {
    return {
      isLogin: true,
      activeFooter: 2,
      checkedCartItem: [], //当前选中的购物车项目id
      allCartItem: [], // 用户所有的购物车项目id列表
      cartList: [],
      checkCarList:[],
      checkedAll: true,
      showEdit: false,
      rightText: "编辑",
      activeses: 2,
      props: [""],
    };
  },
  mounted() {
    this.init();
  },
  computed: {
    submitBarText() {
      const count = this.checkedCartItem.length;
      return "结算" + (count ? `(${count})` : "");
    },
    totalPrice() {
      return this.cartList.reduce(
        (total, item) =>
          total +
          (this.checkedCartItem.indexOf(item.id) !== -1
            ? parseFloat(item.price) * item.count*100
            : 0),
        0
      );
    },
  },
  methods: {
    checkInfo(item){    //得到所有商品长度和购买长度
        if(this.checkedCartItem.length==this.allCartItem.length){
            this.checkedAll=true;
        }else{
           this.checkedAll=false;
        }
    },
    init() {    //初始化查找购物车
      let _this = this;
      let url = "/memberBusiness/car/selectCar";
      return new Promise((resolve, reject) => {
        _this.$axios
          .get(url)
          .then((data) => {
            _this.cartList = data.data;
            _this.checkCarList=data.data; //得到所有选中
             for (let item in  _this.cartList) {
                  _this.allCartItem.push( _this.cartList[item].id);
             }
               _this.checkedCartItem=_this.allCartItem;

          })
          .catch((erro) => {
            reject(erro);
          });
      });
    },
    toCheckOut() {

      var that=this;
      //得到选中的商品
      const result2 = that.cartList.filter(item =>  that.checkedCartItem.indexOf(item.id) != -1);
      sessionStorage.setItem("buyData", JSON.stringify(result2));  //放入对象数组
     
      this.$router.push({path:'/checkout'});

    
    },
    formatPrice(price) {
      return (price / 100).toFixed(2);
    },
    stepperEvent(item, arg) {
      //更新数据
      // const count = arg[0];  //数量
      const url = "/memberBusiness/car/updateCar";
      this.$axios
        .post(url, item)
        .then((data) => {
          //更新数据
        })
        .catch((error) => {
          //请求失败返回的数
          Toast({
            message: error.message,
            position: "middle",
            duration: 2000,
          });
        });
    },
    toHome() {
      this.$router.push("/home");
    },
    toLogin() {
      this.$router.push({ path: "login", query: { redirect: "cart" } });
    },
    checkAll() {
      if (this.checkedAll === true) {
        this.checkedCartItem = this.allCartItem;
      } else {
        this.checkedCartItem = [];
      }

     
    },
    onClickRight() {
      if (this.showEdit === true) {
        this.showEdit = false;
        this.rightText = "编辑";
      } else {
        this.showEdit = true;
        this.rightText = "完成";
      }
    },
    remove() {
      var submitData = { ids: this.checkedCartItem.join(",") };

      const url = "/memberBusiness/car/deleteCar";
      this.$axios
        .post(url, submitData)
        .then((data) => {
          //更新数据
          Toast({
            message: data.message,
            position: "middle",
            duration: 2000,
          });
          if ((data.code = 200)) {
            this.init();
          }
        })
        .catch((error) => {
          //请求失败返回的数
          Toast({
            message: error.message,
            position: "middle",
            duration: 2000,
          });
        });

    },
  },
};
</script>

<style lang="less">
.cart {
  .no-data {
    margin-top: 60%;
  }
}
.van-submit-bar {
  bottom: 48px;
}
.card-goods {
  background-color: #fff;

  &__item {
    position: relative;
    background-color: #fafafa;

    .van-checkbox__label {
      width: 100%;
      height: auto; // temp
      padding: 0 10px 0 15px;
      box-sizing: border-box;
    }

    .van-checkbox__icon {
      top: 50%;
      left: 10px;
      z-index: 1;
      position: absolute;
      margin-top: -10px;
    }

    .van-card__price {
      color: #f44;
    }
  }
}
</style>
